import { useState, useEffect } from 'react';
import { mastersAPI, heardFromAPI } from '../../../services/api';
import { normalizeApiListResponse } from '../../../utils/apiListNormalize';

const fetchMasterList = async (type, setter, label) => {
  try {
    const res = await mastersAPI.list(type);
    setter(normalizeApiListResponse(res.data));
  } catch (err) {
    console.error(`Failed to fetch ${label.toLowerCase()}:`, err.response?.data || err.message);
    setter([]);
  }
};

/** Masters + heard-from dropdowns (ISP: consumers that only need these can import this hook later). */
export function useAdminFormMasters(token) {
  const [roles, setRoles] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [universityOptions, setUniversityOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [heardFromOptions, setHeardFromOptions] = useState([]);

  useEffect(() => {
    if (!token) return;

    fetchMasterList('role', setRoles, 'Roles');
    fetchMasterList('degree', setEducationOptions, 'Education Degrees');
    fetchMasterList('university', setUniversityOptions, 'University Options');
    fetchMasterList('company', setCompanyOptions, 'Company Options');

    heardFromAPI
      .getAll()
      .then((res) => setHeardFromOptions(normalizeApiListResponse(res.data)))
      .catch((err) => {
        console.error('Failed to fetch heardfrom options:', err);
        setHeardFromOptions([]);
      });
  }, [token]);

  const refreshCompanyOptions = async () => {
    if (!token) return;
    try {
      const res = await mastersAPI.list('company');
      setCompanyOptions(normalizeApiListResponse(res.data));
    } catch (err) {
      console.error('Failed to refresh company options:', err.response?.data || err.message);
    }
  };

  return {
    roles,
    educationOptions,
    universityOptions,
    companyOptions,
    heardFromOptions,
    refreshCompanyOptions
  };
}
